import { updateUserNotificationPreferencesPatch } from '@/services/api/requests/user';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { TNotificationChannel } from '@/types/Notification.types';

const useUpdateNotificationPreferences = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate, isError } = useMutation({
    mutationFn: async (newNotificationPreferences: TNotificationChannel[]) => {
      const user = await updateUserNotificationPreferencesPatch(newNotificationPreferences);
      return user;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success!',
        description: 'Successfully updated Notification Preferences',
      });
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error while updating notification preferences',
      }, error);
    },
  });

  return { isPending, mutate, isError };
};

export default useUpdateNotificationPreferences;
